module.exports = __webpack_public_path__ + "static/media/ladies-with-phone.53936cd8.png";